/* Essence Garden – Proben entdecken: Reihen-Pfeile, Kachel-Sprünge und Zufallsduft */
(function(){

  /* Kacheln mit Anker: zu Block-ID oder Abschnitt der Vorlage (…__proben_neu) springen */
  if (!window.__egpdJump) { window.__egpdJump = true;
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('a[data-pd-jump]');
    if (!a) return;
    var key = (a.getAttribute('href') || '').split('#')[1];
    if (!key) return;
    var el = document.getElementById(key) || document.querySelector('[id$="__' + key + '"]');
    if (!el) return;
    e.preventDefault();
    var top = el.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: top, behavior: 'smooth' });
  });
  }
  document.querySelectorAll('[data-pd-root]').forEach(function(root){
  if (root.dataset.pdInit) return;
  root.dataset.pdInit = '1';

  /* Pfeile an den Produktreihen */
  root.querySelectorAll('.pd-block').forEach(function(block){
    var track = block.querySelector('[data-pd-track]');
    if (!track) return;
    var prev = block.querySelector('[data-pd-prev]');
    var next = block.querySelector('[data-pd-next]') || block.querySelector('[data-pd-next-in]');
    function step(){ var c = track.querySelector('.pd-rail__item'); return c ? (c.getBoundingClientRect().width + 16) * 2 : 400; }
    function update(){
      if (prev) prev.disabled = track.scrollLeft <= 4;
      var n = block.querySelector('[data-pd-next]');
      if (n) n.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    if (prev) prev.addEventListener('click', function(){ track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function(){
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) { track.scrollTo({ left: 0, behavior: 'smooth' }); }
      else { track.scrollBy({ left: step(), behavior: 'smooth' }); }
    });
    track.addEventListener('scroll', update, { passive: true });
    update();
  });

  /* Überrasch mich: zufälliger Duft aus der Kollektion (Liste im Kopfband), sonst aus den Reihen */
  var shuffle = root.querySelector('[data-pd-shuffle]');
  if (shuffle) {
    shuffle.addEventListener('click', function(){
      var urls = [];
      var pool = root.querySelector('[data-pd-pool]');
      try { urls = JSON.parse(pool.textContent).filter(Boolean); } catch (e) {}
      if (!urls.length) {
        urls = Array.prototype.map.call(root.querySelectorAll('[data-pd-card] a[href*="/products/"]'), function(a){ return a.getAttribute('href'); });
      }
      if (!urls.length) return;
      window.location.href = urls[Math.floor(Math.random() * urls.length)];
    });
  }
  });
})();